// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-header {
  background: #ffffff;
  margin: 0;
  border-bottom: 1px solid black;
  width: 100%;
}

.user-header h1 {
  font-size: 20px;
  font-weight: 500;
  margin: 0;
  color: #181818;
  text-align: left;
  width: 100%;
}

.header {
  width: 100%;
  padding: 10px;
  height: 3%;
  display: flex;

  mat-panel-title {
    color: white;
  }
}

.form-accordian {
  margin-bottom: 10px;
}

input {
  width: 100%;
}

select {
  width: 100%;
}

#comments {
  width: 98.9%;
}
`, "",{"version":3,"sources":["webpack://./projects/ert/src/app/ert-user/new-user/ert-new-user-details/ert-new-user-details.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,UAAU;EACV,aAAa;;EAEb;IACE,YAAY;EACd;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd","sourcesContent":[".user-header {\n  background: #ffffff;\n  margin: 0;\n  border-bottom: 1px solid black;\n  width: 100%;\n}\n\n.user-header h1 {\n  font-size: 20px;\n  font-weight: 500;\n  margin: 0;\n  color: #181818;\n  text-align: left;\n  width: 100%;\n}\n\n.header {\n  width: 100%;\n  padding: 10px;\n  height: 3%;\n  display: flex;\n\n  mat-panel-title {\n    color: white;\n  }\n}\n\n.form-accordian {\n  margin-bottom: 10px;\n}\n\ninput {\n  width: 100%;\n}\n\nselect {\n  width: 100%;\n}\n\n#comments {\n  width: 98.9%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
